// src/activities/wvd/wvd-event-files/WorldMap.jsx

// Tinc un altre mapa reutilitzable en un altre lloc

import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import countryOptions from "../../../constants/countryOptions";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// Construeix un mapping de nom de país a codi ISO.
// Les claus són els noms dels països en minúscules.
const nameToIso = {};
countryOptions.forEach(option => {
  nameToIso[option.label.toLowerCase()] = option.value;
});

const WorldMap = ({ data = [] }) => {
  // Construir un mapping de codi ISO a nombre d’avaluacions
  const dataMap = {};
  data.forEach(d => {
    if (typeof d._id === 'string') {
      dataMap[d._id.toUpperCase()] = d.count;
    } else {
      console.warn('Invalid or missing country code:', d);
    }
  });  

  // Funció per obtenir el color en funció del nombre d’avaluacions:
  // Si hi ha avaluacions, es mostra verd; si no, gris.
  const getColor = (count) => {
    if (count <= 0) return "#EEE"; // Cap avaluació: color per defecte
    if (count >= 1 && count <= 5) return "#edbda8";
    if (count >= 6 && count <= 10) return "#ee975c";
    if (count >= 11 && count <= 20) return "#ef682b";
    if (count >= 21 && count <= 50) return "#d52e1a";
    // Més de 500 avaluacions
    return "#aa2621";
  };

  return (
    <ComposableMap projectionConfig={{ scale: 150 }} width={800} height={400}>
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies.map(geo => {
            const countryName = geo.properties.name;
            // Converteix el nom a minúscules i busca el codi ISO corresponent
            const isoCode = nameToIso[countryName.toLowerCase()];
            // Si s'ha trobat el codi, utilitza'l per obtenir el compte; altrament, 0.
            const count = isoCode ? dataMap[isoCode] || 0 : 0;
            
            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill={getColor(count)}
                stroke="#f5f5f5"
                strokeWidth={0.5}
                style={{
                  default: { outline: "none" },
                  hover: { fill: getColor(count), outline: "none" },
                  pressed: { outline: "none" }
                }}
              />
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
};

export default WorldMap;
